import { useRoutes } from 'react-router-dom';
import routes from './Routes';

const RouterProvider = () => {
  const routing = useRoutes(routes);
  return routing;
};

export default RouterProvider;
